module.exports = __webpack_public_path__ + "img/kazakhstan.4baee56.webp";